import styled, { css } from 'styled-components';

export const HeaderDisplay = styled.div``;

export const TextEllispis = styled.div`
  text-overflow: ellipsis;
  overflow: hidden;

  &:hover {
    ${(props) =>
      props.interactive &&
      css`
        cursor: pointer;
      `}
  }
`;

export const HeaderFullContainer = styled.div`
  margin: 0 6px;
`;

export const HeaderContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  min-height: 54px;
  padding: 0 25px 0 0;
`;

export const TitleColumn = styled.div`
  display: flex;
  font-size: 14px;

  overflow: hidden;

  padding-left: ${(props) => (props.isFirst ? '16px' : '15px')};

  flex: ${(props) => (props.large ? 2 : 1)};

  ${(props) =>
    props.large &&
    !props.isFirst &&
    css`
      flex-basis: calc(${(100 / props.nbColumn) * 2}%);
    `}

  ${(props) =>
    !props.large &&
    !props.isFirst &&
    css`
      flex-basis: calc(${100 / props.nbColumn}%);
    `}

  ${(props) =>
    props.large &&
    props.isFirst &&
    css`
      flex-basis: calc(${(100 / props.nbColumn) * 2}%);
    `}

  ${(props) =>
    !props.large &&
    props.isFirst &&
    css`
      flex-basis: calc(${100 / props.nbColumn}%);
    `}

  ${(props) =>
    props.narrow &&
    css`
      width: fit-content;
      flex: none;
    `}

  ${(props) =>
    props.minWidth &&
    css`
      min-width: ${props.minWidth}px;
    `}

  color: ${(props) => {
    if (props.selected) {
      return props.theme.header?.selected?.color;
    }

    return props.theme.header?.default?.color;
  }};

  font: ${(props) => {
    if (props.selected) {
      return props.theme.header?.selected?.font;
    }

    return props.theme.header?.default?.font;
  }};
`;

export const Icon = styled.img`
  margin: ${(props) =>
    props.marginLeft ? `auto 0 auto ${props.marginLeft}` : `auto 0 auto 0`};

  &:hover {
    ${(props) =>
      props.interactive &&
      css`
        cursor: pointer;
      `}
  }
`;

export default {
  HeaderFullContainer,
  HeaderDisplay,
  HeaderContainer,
  TitleColumn,
  Icon,
  TextEllispis,
};
